import { Injectable } from '@angular/core';


import {
     MyAccountDetails, MembershipInfo, PrimaryContact, Phones, Section, Chapter, Addresses,
    CustomerAddress, PersonalInfo, MedicalSchool, Internship, Residency, Fellowship, Education, Credentials, BoardCertification,
    MedicalLicense, Career, EMCareer, Military, PrimaryEmployer, PaymentDetails, BillingOption
} from '../../shared/models/my-account-data.models';
import { AppUiData, Address, Questionnaire } from '../../shared/models/common.data.models'
import { AcepSSOService, GlobalDataOpsService, CommonOperationsService } from '@acepteam/globalspack';
import { DataService } from '../../core/services';

declare var $: any;
declare var moment: any;

@Injectable(
    {
      providedIn: "root"
    }
  )
  export class MyAccountDataOpsService {


    //QUESTIONNAIREKEYS

    // private Key_PracticingEM = 'CurrentlyPracticingEM';
    // private Key_WorkingAtEMCare = 'WorkingatEMCareOrUrgentCare';
    private Key_PrimaryPracticeLocation = 'PrimaryPracticeLocation';
    private Key_YearBeganEM = 'YearBeganEM';
    private Key_EmploymentStatus = 'EmploymentStatus';
    private Key_DashboardPreferences = 'DashboardPreferences';


    public Key_MANUALMEDICALSCHOOL = 'MANUALMEDICALSCHOOL';
    public Key_MANUALRESIDENCY = 'MANUALRESIDENCY';
    public Key_MANUALINTERNSHIP = 'MANUALINTERNSHIP';
    public Key_MANUALBOARDCERTIFICATION = 'MANUALBOARDCERTIFICATION';
    public Key_MANUALFELLOWSHIP = 'MANUALFELLOWSHIP';
    public Key_MANUALPRIMARYEMPLOYER = 'MANUALPRIMARYEMPLOYER';

    public Key_MANUALPAPROGRAM = 'MANUALPAPROGRAM';
    public Key_MANUALPGPROGRAM = 'MANUALPGPROGRAM';

    public PrimaryEmployer_PositionIdFor_EMPLOYEE = '';

    public myaccountdata: MyAccountDetails;

    constructor( private ssosvc: AcepSSOService, private globalDataOpsService: GlobalDataOpsService, private dataService: DataService, private commonopssvc: CommonOperationsService) {
    }

   

    //Map Data for MyAccountHome Component
    public MapMyAccountData(json_myaccdata) {
        this.myaccountdata = new MyAccountDetails();

        let json_Contact = json_myaccdata.Table;
        let json_Addresses = json_myaccdata.Table1;
        //let json_Membership = json_myaccdata.Table2;        
        //let json_Transactions = json_myaccdata.Table5;
        //let json_PaymentDetails = json_myaccdata.Table6;
        //let json_MemberDirectorySettings = json_myaccdata.Table7;
        let json_BoardCertifications = json_myaccdata.Table2;
        let json_MedicalSchools = json_myaccdata.Table3;
        let json_Residencies = json_myaccdata.Table4;
        let json_Fellowships = json_myaccdata.Table5;
        let json_MedicalLicenses = json_myaccdata.Table6;
        //let json_Military = json_myaccdata.Table13;
        //let json_PrimaryEmployers = json_myaccdata.Table14; //AccountContacts
        let json_QuestionnaireAnswers = json_myaccdata.Table7;
        this.myaccountdata.QuestionDefinitions = json_myaccdata.Table8;
        // let json_Sections = json_myaccdata.Table9;
        // let json_Chapters = json_myaccdata.Table10;
        let json_AccountProducts = json_myaccdata.Table9;
        //let json_Subscriptions = json_myaccdata.Table17;
        //let json_LeadershipBodies = json_myaccdata.Table18;
        //let json_LeadershipPositions = json_myaccdata.Table19;
        //let json_SempaPAPG = json_myaccdata.Table20;
        //let json_Facep = json_myaccdata.Table21;
        let json_ContentSnippets = json_myaccdata.Table10;
        let json_SalesOrders = json_myaccdata.Table11;


        
        this.myaccountdata.primaryContact = this.MapPrimaryContact(json_Contact);
        
        // this.myaccountdata.membershipInfo = this.MapMembership(json_Membership, json_Facep)
        
        // this.myaccountdata.paymentDetailsOnFile = this.MapPaymentDetails(json_PaymentDetails);
        // this.myaccountdata.sections = this.MapSections(json_Sections);
        // this.myaccountdata.chapters = this.MapChapters(json_Chapters);
        
        this.myaccountdata.addresses = this.MapAddresses(json_Addresses);
        this.myaccountdata.education = this.MapEducation(json_QuestionnaireAnswers, json_MedicalSchools, json_Residencies, json_Fellowships);
        this.myaccountdata.credentials = this.MapCredentials(json_QuestionnaireAnswers, json_BoardCertifications, json_MedicalLicenses);
        // this.myaccountdata.career = this.MapCareer(json_QuestionnaireAnswers, json_Contact, json_Military, json_PrimaryEmployers);

        this.myaccountdata.AccountProducts = json_AccountProducts;
        this.myaccountdata.SalesOrders = json_SalesOrders;
        this.myaccountdata.ContentSnippets = json_ContentSnippets;
        
       return this.myaccountdata;

    }

    

    private MapBillingOption(j): BillingOption {

        let BO: BillingOption = {
            BillingOptionId: j.BillingOptionId,
            PaymentMethodId: j.PaymentMethodId,
            Acep_CCLast4Digits: j.Acep_CCLast4Digits,
            CCExpiryDate: j.CCExpiryDate,
            InstallmentOrRenewalDate: j.InstallmentOrRenewalDate,
            IsOnAutoRenewal: j.IsOnAutoRenewal,
            OnInstallments: j.OnInstallments,
            PaymentType: j.PaymentType,
            ProductName: j.ProductName,
            PaymentStatus: j.PaymentStatus,
            PaymentMethodOrgCode: j.PaymentMethodOrgCode,
        }

        return BO;
    }


   
    private MapPaymentDetails(jRows): PaymentDetails[] {

        let paymentdetails: PaymentDetails[] = [];
        for (let j of jRows) {
            paymentdetails.push(
                {
                    ProfileId: j.profileid,
                    CCExpirationDate: j.expirydate,
                    CreditCardNumber: j.last4digits,
                    PostalCode: j.zipcode,
                    CardType: j.paymenttype,
                    OrgCode: j.orgcode,
                    PaymentMethodId: j.paymentmethodid
                }

            );
        }

        //    Acep - 1
        //    Emra -2
        //    Sempa - 4
        //    EMf - 5
        //    NEMPAC - 6


        if (this.globalDataOpsService.ORG == 'ACEP') {
            paymentdetails = paymentdetails.filter(p => p.OrgCode == 1);
        }
        else if (this.globalDataOpsService.ORG == 'EMRA') {
            paymentdetails = paymentdetails.filter(p => p.OrgCode == 2);
        }
        else if (this.globalDataOpsService.ORG == 'SEMPA') {
            paymentdetails = paymentdetails.filter(p => p.OrgCode == 4);
        }



        return paymentdetails;

    }

    private MapAvatar(jRows) {
        let _avatar = jRows[0].avatar == '' ? this.ssosvc.defaultAvatar : jRows[0].avatar;
        _avatar = _avatar.replace('http://', 'https://');
        return _avatar; //this.processimage(jRows[0].EntityImage);
    }

    private MapPrimaryContact(jRows): PrimaryContact {
        let pc: PrimaryContact = new PrimaryContact();
        let jRow = jRows && jRows[0];
        if (jRow) {
            pc.email = jRow.Email;
            pc.username = jRow.Username;
            pc.phones = this.GetPhones(jRow);
            pc.personalinfo = this.MapPersonalInformation(jRow);
            pc.acepid = this.ssosvc.acepid;
        }

        return pc;
    }


    private MapPersonalInformation(jRow: any): PersonalInfo {

        let pi: PersonalInfo =
            {
                dob: jRow.DOB,
                ethnicity: jRow.Ethnicity,
                firstname: jRow.FirstName,
                middlename: jRow.MiddleName,
                gender: jRow.Gender,
                jobtitle: jRow.JobTitle,
                lastname: jRow.LastName,
                prefix: jRow.Prefix,
                professionaldesignation: jRow.ProfessionalDesignation,
                suffix: jRow.Suffix,
                formalname: jRow.FormalName

            }

        return pi;
    }

    private MapACustomerAddress(j: any): CustomerAddress {
        let ca: CustomerAddress = new CustomerAddress();

        ca = {
            addressid: j.CustomerAddressId,
            isprimary: j.IsPrimary == 1,
            addresstype: j.AddressTypeCodeName,
            address: {
                address1: j.AddressLine1 == null ? '' : j.AddressLine1,
                address2: j.AddressLine2 == null ? '' : j.AddressLine2,
                address3: j.AddressLine3 == null ? '' : j.AddressLine3,
                city: j.City,
                state: j.StateOrProvince,
                country: j.Country ? j.Country : 'US',
                zip: j.PostalCode
            }
        }

        return ca;

    }

    private MapAddresses(jRows): Addresses {
        let ads: Addresses = new Addresses();
        for (let j of jRows) {
            // let k = JSON.parse(a);
            if (j.AddressTypeCodeName == 'Home' || !j.AddressTypeCodeName) {
                ads.home = this.MapACustomerAddress(j);
            }
            else if (j.AddressTypeCodeName == 'Hospital') {
                ads.hospital = this.MapACustomerAddress(j);
            }
            else if (j.AddressTypeCodeName == 'Business') {
                ads.business = this.MapACustomerAddress(j);
            }
        }

        ads.home.addresstype = "Home";
        ads.hospital.addresstype = "Hospital";
        ads.business.addresstype = "Business";

        return ads;
    }





    private GetPhones(jRow: any): Phones {

        let phones: Phones =
            {
                primaryphone: jRow.PrimaryPhone,
                primaryphoneext: jRow.PrimaryPhoneExt,
                businessphone: jRow.BusinessPhone,
                businessphoneext: jRow.BusinessPhoneExt,
                homephone: jRow.HomePhone,
                homephoneext: jRow.HomePhoneExt,
                hospitalphone: jRow.HospitalPhone,
                hospitalphoneext: jRow.HospitalPhoneExt,
                cellphone: jRow.CellPhone,
                primary: ''
            }

        let primaryphone = phones.primaryphone.replace(/\D/g, "");
        let cellphone = phones.cellphone.replace(/\D/g, "");
        let homephone = phones.homephone.replace(/\D/g, "");
        let hospitalphone = phones.hospitalphone.replace(/\D/g, "");
        let businessphone = phones.businessphone.replace(/\D/g, "");


        if (primaryphone == cellphone) {
            phones.primary = "Mobile";
        }
        else if (primaryphone == homephone) {
            phones.primary = "Home";
            if (phones.homephoneext == '') {
                phones.homephoneext = phones.primaryphoneext;
            }
        }
        else if (primaryphone == hospitalphone) {
            phones.primary = "Hospital";
            if (phones.hospitalphoneext == '') {
                phones.hospitalphoneext = phones.primaryphoneext;
            }
        }
        else if (primaryphone == businessphone) {
            phones.primary = "Business";
            if (phones.businessphoneext == '') {
                phones.businessphoneext = phones.primaryphoneext;
            }
        }

        return phones;

    }

    private MapMembership(json_Membership, json_Facep): MembershipInfo {
        let m: MembershipInfo = new MembershipInfo();

        let dtformat = 'MM/DD/YYYY';
        let MONTHS_RENEWAL = 2;
        let MONTHS_REINSTATEMENT = 6;
        let MONTHS_GRACE = -3;
        let today = moment(); //moment('5/1/2016'); ////now
        let currentExpDate = moment(m.expirationDate);
        let readyForRenewalDate = moment(m.expirationDate).add(MONTHS_GRACE, 'M');
        let numberofmonthsSinceExpirationDate = today.diff(currentExpDate, 'months', true);

        let usercontext = this.ssosvc.context.user;
        let membershipType: string = usercontext.MemberType;
        let expirationDate: string = this.commonopssvc.SantizeDate(usercontext.Acep_ExpirationDate);
        let memberRateCode: string = usercontext.ACEPRate;
        let orgcode = 1;

        // let tempORG: string = this.commonopssvc.DeepCopyObject(this.dataService.ORG);
        // //let memberSince: string = this.commonopssvc.SantizeDate(jRow.JoinDate);

        // //if emra member logging in not on acep/erma dashboard

        // if(usercontext.EMRAMemberType != '' && this.dataService.ORG != "SEMPA")
        // {
        //     tempORG = "EMRA";
        // }


        if (this.globalDataOpsService.ORG == "ACEPEMRA") {
            membershipType = usercontext.MemberType + ' / ' + usercontext.EMRAMemberType

        }
        else if (this.globalDataOpsService.ORG == "EMRA") {
            membershipType = usercontext.EMRAMemberType;
            expirationDate = this.commonopssvc.SantizeDate(usercontext.Emra_ExpirationDate);
            memberRateCode = usercontext.EMRARate;
            orgcode = 2;
        }
        else if (this.globalDataOpsService.ORG == "SEMPA") {
            membershipType = usercontext.MemberType
            expirationDate = this.commonopssvc.SantizeDate(usercontext.Sempa_ExpirationDate);
            memberRateCode = usercontext.SEMPARate;
            orgcode = 3;
        }



        let jRows = json_Membership && json_Membership.filter(function (s) { return s.OrganizationCode === orgcode });
        let jRow = jRows && jRows[0];
        if (jRow) {
            m = {
                membershipId: this.ssosvc.acepid,
                expirationDate: expirationDate,
                membershipType: membershipType, //jRow.MemberTypeCode == null ? '' : jRow.MemberTypeCode,
                membershipRate: memberRateCode == null ? '' : memberRateCode,
                memberSince: this.commonopssvc.SantizeDate(jRow.JoinDate),
                isFacep: this.ssosvc.isacepmember && json_Facep.length > 0,
                facepSince: json_Facep.length > 0 ? json_Facep[0].begindate : '',

                isAFormerMember: jRow.ExpirationDate != null,
                isUnderRenewalPeriod: (numberofmonthsSinceExpirationDate <= MONTHS_REINSTATEMENT),

                BO: this.MapBillingOption(jRow)
            }
        }

        return m;
    }


   
    //Map Data for Sections
    private MapSections(jRows): Section[] {
        let sections: Section[] = [];
        for (let j of jRows) {
            sections.push(
                {
                    name: j.sectionname,
                    sectionid: j.sectionid,
                    sectionmemberid: j.sectionmemberid,
                    allowemail: j.allowemail,
                    allowelist: j.allowelist,
                    websiteurl: j.websiteurl
                }

            );
        }
        return sections;
    }

    //Map Data for Chapters
    private MapChapters(jRows): Chapter[] {
        let chapters: Chapter[] = [];
        for (let j of jRows) {
            chapters.push(
                {
                    name: j.chaptername,
                    chapterid: j.chapterid,
                    chaptermemberid: j.chaptermemberid,
                    allowemail: j.allowemail,
                    websiteurl: j.websiteurl
                }
            );
        }
        return chapters;
    }

   

    private capitalizeFirstLetter(str: string) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }



    

    private MapCredentials(json_QuestionAnswers, json_BoardCertifications, json_MedicalLicenses): Credentials {
        let credentials: Credentials =
            {
                boardcertifications: this.MapBoardCertifications(json_QuestionAnswers, json_BoardCertifications),
                medicallicenses: this.MapMedicalLicenses(json_MedicalLicenses)
            }

        return credentials;

    }

    private MapBoardCertifications(json_QuestionAnswers, jRows): BoardCertification[] {
        let boardcertifications: BoardCertification[] = [];

        jRows = jRows.filter(a=>a.org != 3);

        for (let j of jRows) {

            // let _metaBoardCertification: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALBOARDCERTIFICATION, json_QuestionAnswers, j.contactboardcertificationid);
            // let answervalue: any = "";
            // let manualaccountname: any = "";
            // if (_metaBoardCertification.answervalue != '') {
            //     answervalue = JSON.parse(_metaBoardCertification.answervalue);
            //     //Notes: answer value has name in it which show be assigned to name and deleted so that it can be assgined to address object
            //     manualaccountname = answervalue.name;
            //     delete answervalue.name; //we are deleting the name property from teh answervalue Json
            // }
            // let _AddressBoardCertification: Address = _metaBoardCertification.answervalue == '' ? new Address() : answervalue;
            // let _name: string = (_AddressBoardCertification.address2 == "") ? j.name : manualaccountname;


            boardcertifications.push(
                {
                    id: j.id,
                    contactboardcertificationid: j.contactboardcertificationid,
                    name: j.name,
                    certificationnumber: j.certificationnumber,
                    effectivedate: j.originalcertificationdate,
                    expirationdate: j.expirationdate,
                    // address: _AddressBoardCertification,
                    // metadata: _metaBoardCertification
                }
            );
        }

        //If no accoutns found..add one by default.
        if (boardcertifications.length == 0) {
            boardcertifications.push(this.GiveANewBoardCertificaiton());

        }

        return boardcertifications;
    }

    GiveANewBoardCertificaiton() {
        let m: BoardCertification = new BoardCertification();
        // let _metaBoardCertificaiton: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALBOARDCERTIFICATION, []);
        // m.metadata = _metaBoardCertificaiton;
        return m;
    }

    private MapMedicalLicenses(jRows): MedicalLicense[] {



        let medicallicenses: MedicalLicense[] = [];

        for (let j of jRows) {


            medicallicenses.push(
                {
                    contactmedicallicenseid: j.contactmedicallicenseid,
                    licensecountry: j.country == '' ? 'US' : j.country,
                    licensestateprovince: j.stateprovince,
                    licensedate: j.licensedate,
                    licensenumber: j.licensenumber,
                    licensetypecode: j.licensetypecode
                }
            );
        }

        //If no accoutns found..add one by default.
        if (medicallicenses.length == 0) {
            medicallicenses.push(this.GiveANewMedicalLicense());

        }

        return medicallicenses;

    }

    GiveANewMedicalLicense() {
        let m: MedicalLicense = new MedicalLicense();
        // let _metaBoardCertificaiton: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALBOARDCERTIFICATION, []);
        // m.metadata = _metaBoardCertificaiton;
        return m;
    }

    private MapCareer(json_QuestionAnswers, json_Contact, json_Military, json_AccountContacts): Career {
        let c: Career = {
            emcareer: this.MapEMCareer(json_QuestionAnswers, json_Contact),
            employers: this.MapPrimaryEmployers(json_QuestionAnswers, json_AccountContacts),
            military: this.MapMilitary(json_Military)
        }
        return c;

    }

    private MapEMCareer(json_QuestionAnswers, json_Contact): EMCareer {
        let emcareer: EMCareer = new EMCareer();
        let jRow = json_Contact && json_Contact[0];
        if (jRow) {
            emcareer =
                {
                    ama: jRow.ama,
                    aoa: jRow.aoa,
                    npi: jRow.npi,
                    careerstatus: jRow.careerstatus,
                    employmentstatus: this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_EmploymentStatus, json_QuestionAnswers),
                    yearbeganem: this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_YearBeganEM, json_QuestionAnswers),
                    primarypracticelocation: this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_PrimaryPracticeLocation, json_QuestionAnswers)

                }
        }

        return emcareer;

    }

    private MapMilitary(jRows): Military {
        let m: Military = new Military();
        let jRow = jRows && jRows[0];
        if (jRow) {
            m = {
                begindate: jRow.begindate,
                enddate: jRow.enddate,
                branch: jRow.branch.trim(),
                rank: jRow.rank.trim(),
                contactmilitaryid: jRow.contactmilitarytourid
            }
        }

        return m;

    }


    private MapEducation(json_QuestionAnswers, json_medschool, json_residency, json_fellowship): Education {

        let education: Education =
            {
                medicalschools: this.MapMedicalSchools(json_QuestionAnswers, json_medschool),
                internships: this.MapInternships(json_QuestionAnswers, json_residency.filter(function (s) { return s.position === 3 })),
                residencies: this.MapResidencies(json_QuestionAnswers, json_residency.filter(function (s) { return s.position === 1 })),
                fellowships: this.MapFellowships(json_QuestionAnswers, json_fellowship)
            }

        return education;

    }

    private MapMedicalSchools(json_QuestionAnswers, jRows): MedicalSchool[] {
        let medicalschools: MedicalSchool[] = [];

        for (let j of jRows) {

            let _metaMedicalSchool: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALMEDICALSCHOOL, json_QuestionAnswers, j.contactmedicalschoolid);
            let answervalue: any = "";
            let manualaccountname: any = "";
            if (_metaMedicalSchool.answervalue != '') {
                answervalue = JSON.parse(_metaMedicalSchool.answervalue);
                //Notes: answer value has name in it which show be assigned to name and deleted so that it can be assgined to address object
                manualaccountname = answervalue.name;
                delete answervalue.name; //we are deleting the name property from teh answervalue Json
            }
            let _AddressMedicalSchool: Address = _metaMedicalSchool.answervalue == '' ? new Address() : answervalue;
            let _name: string = (_AddressMedicalSchool.address2 == "") ? j.name : manualaccountname;


            medicalschools.push(
                {
                    id: j.id,
                    contactmedicalschoolid: j.contactmedicalschoolid,
                    graduationdate: j.graduationdate,
                    name: _name,
                    address: _AddressMedicalSchool,
                    metadata: _metaMedicalSchool
                }
            );
        }

        //If no accoutns found..add one by default.
        if (medicalschools.length == 0) {
            medicalschools.push(this.GiveANewMedicalSchool());

        }

        return medicalschools;
    }

    GiveANewMedicalSchool() {
        let m: MedicalSchool = new MedicalSchool();
        let _metaMedicalSchool: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALMEDICALSCHOOL, []);
        m.metadata = _metaMedicalSchool;
        return m;
    }



    private MapInternships(json_QuestionAnswers, jRows): Internship[] {
        let internships: Internship[] = [];

        for (let j of jRows) {

            let _metaInternship: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALINTERNSHIP, json_QuestionAnswers, j.contactresidencyid);
            let answervalue: any = "";
            let manualaccountname: any = "";
            if (_metaInternship.answervalue != '') {
                answervalue = JSON.parse(_metaInternship.answervalue);
                //Notes: answer value has name in it which show be assigned to name and deleted so that it can be assgined to address object
                manualaccountname = answervalue.name;
                delete answervalue.name; //we are deleting the name property from teh answervalue Json
            }
            let _AddressInternship: Address = _metaInternship.answervalue == '' ? new Address() : answervalue;
            let _name: string = (_AddressInternship.address2 == "") ? j.name : manualaccountname;


            internships.push(
                {
                    id: j.id,
                    contactresidencyid: j.contactresidencyid,
                    graduationdate: j.graduationdate,
                    name: _name,
                    address: _AddressInternship,
                    metadata: _metaInternship
                }
            );
        }

        //If no accoutns found..add one by default.
        if (internships.length == 0) {
            internships.push(this.GiveANewInternship());

        }

        return internships;
    }

    GiveANewInternship() {
        let m: Internship = new Internship();
        let _metaInternship: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALINTERNSHIP, []);
        m.metadata = _metaInternship;
        return m;
    }


    private MapResidencies(json_QuestionAnswers, jRows): Residency[] {
        let residencies: Residency[] = [];

        for (let j of jRows) {

            let _metaResidency: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALRESIDENCY, json_QuestionAnswers, j.contactresidencyid);
            let answervalue: any = "";
            let manualaccountname: any = "";
            if (_metaResidency.answervalue != '') {
                answervalue = JSON.parse(_metaResidency.answervalue);
                //Notes: answer value has name in it which show be assigned to name and deleted so that it can be assgined to address object
                manualaccountname = answervalue.name;
                delete answervalue.name; //we are deleting the name property from teh answervalue Json
            }
            let _AddressResidency: Address = _metaResidency.answervalue == '' ? new Address() : answervalue;
            let _name: string = (_AddressResidency.address2 == "") ? j.name : manualaccountname;


            residencies.push(
                {
                    id: j.id,
                    contactresidencyid: j.contactresidencyid,
                    graduationdate: j.graduationdate,
                    specialtyid: j.specialtyid,
                    name: _name,
                    address: _AddressResidency,
                    metadata: _metaResidency
                }
            );
        }

        //If no accoutns found..add one by default.
        if (residencies.length == 0) {
            residencies.push(this.GiveANewResidency());

        }

        return residencies;
    }

    GiveANewResidency() {
        let m: Residency = new Residency();
        let _metaResidency: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALRESIDENCY, []);
        m.metadata = _metaResidency;
        return m;
    }



    private MapFellowships(json_QuestionAnswers, jRows): Fellowship[] {
        let fellowships: Fellowship[] = [];

        for (let j of jRows) {

            let _metaFellowship: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALFELLOWSHIP, json_QuestionAnswers, j.contactfellowshipid);
            let answervalue: any = "";
            let manualaccountname: any = "";
            if (_metaFellowship.answervalue != '') {
                answervalue = JSON.parse(_metaFellowship.answervalue);
                //Notes: answer value has name in it which show be assigned to name and deleted so that it can be assgined to address object
                manualaccountname = answervalue.name;
                delete answervalue.name; //we are deleting the name property from teh answervalue Json
            }
            let _AddressFellowship: Address = _metaFellowship.answervalue == '' ? new Address() : answervalue;
            let _name: string = (_AddressFellowship.address2 == "") ? j.name : manualaccountname;


            fellowships.push(
                {
                    id: j.id,
                    contactfellowshipid: j.contactfellowshipid,
                    graduationdate: j.graduationdate,
                    specialtyid: j.specialtyid,
                    subspecialtyid: j.subspecialtyid,
                    name: _name,
                    address: _AddressFellowship,
                    metadata: _metaFellowship
                }
            );
        }

        //If no accoutns found..add one by default.
        if (fellowships.length == 0) {
            fellowships.push(this.GiveANewFellowship());

        }

        return fellowships;
    }

    GiveANewFellowship() {
        let m: Fellowship = new Fellowship();
        let _metaFellowship: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALFELLOWSHIP, []);
        m.metadata = _metaFellowship;
        return m;
    }


    private MapPrimaryEmployers(json_QuestionAnswers, jRows): PrimaryEmployer[] {
        let thiscomponent = this;

        let primaryemployers: PrimaryEmployer[] = [];
        this.PrimaryEmployer_PositionIdFor_EMPLOYEE = jRows.filter(function (s) { return s.accountcontactid === '' })[0].position;


        //1. Employer Details from jRows(Account Contact)
        jRows = jRows.filter(function (s) { return s.accountcontactid != '' });
        for (let j of jRows) {

            let _metaPrimaryEmployer: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALPRIMARYEMPLOYER, json_QuestionAnswers, j.accountcontactid);
            let answervalue: any = "";
            let manualaccountname: any = "";
            if (_metaPrimaryEmployer.answervalue != '') {
                answervalue = JSON.parse(_metaPrimaryEmployer.answervalue);
                //Notes: answer value has name in it which show be assigned to name and deleted so that it can be assgined to address object
                manualaccountname = answervalue.name;
                delete answervalue.name; //we are deleting the name property from teh answervalue Json
            }
            let _AddressPrimaryEmployer: Address = _metaPrimaryEmployer.answervalue == '' ? new Address() : answervalue;
            let _name: string = (_AddressPrimaryEmployer.address2 == "") ? j.name : manualaccountname;


            primaryemployers.push(
                {
                    id: j.id,
                    accountcontactid: j.accountcontactid,
                    begindate: j.begindate,
                    jobtitle: j.title,
                    position: j.position,
                    name: _name,
                    address: _AddressPrimaryEmployer,
                    metadata: _metaPrimaryEmployer
                }
            );
        }




        //2. Get Employer Details stored ONLY in Questionnaire Aswers. Reason. There is no account for manual primary employer

        let jQRows = json_QuestionAnswers.filter(function (s) { return s.acep_QuestionnaireKey == thiscomponent.Key_MANUALPRIMARYEMPLOYER });

        for (let j of jQRows) {

            // let _metaPrimaryEmployer: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALPRIMARYEMPLOYER, json_QuestionAnswers);
            // let answervalue: any = "";
            // let manualaccountname: any = "";
            // if (_metaPrimaryEmployer.answervalue != '') {
            //     answervalue = JSON.parse(_metaPrimaryEmployer.answervalue);
            //     //Notes: answer value has name in it which show be assigned to name and deleted so that it can be assgined to address object
            //     manualaccountname = answervalue.name;
            //     delete answervalue.name; //we are deleting the name property from teh answervalue Json
            // }
            // let _AddressPrimaryEmployer: Address = _metaPrimaryEmployer.answervalue == '' ? new Address() : answervalue;


            let answervalue: any = JSON.parse(j.Acep_Answer);
            let _AddressPrimaryEmployer: Address = {
                address1: answervalue.address1,
                address2: answervalue.address2,
                address3: answervalue.address3,
                city: answervalue.city,
                country: answervalue.country,
                state: answervalue.state,
                zip: answervalue.zip,
            }
            let _metaPrimaryEmployer: Questionnaire = {
                answerid: j.Acep_QuestionnaireAnswerId,
                answermetadata: "",
                answernotes: "",
                answertype: 5,
                answervalue: answervalue,
                modifiedon: "",
                qndefnid: j.Acep_QuestionaireDefinitionId,
                questionKey: j.acep_QuestionnaireKey,
                questiontext: "MANUAL PRIMARY EMPLOYER"

            }

            primaryemployers.push(
                {
                    id: -1,
                    accountcontactid: "",
                    begindate: answervalue.begindate,
                    jobtitle: answervalue.jobtitle,
                    position: answervalue.position,
                    name: answervalue.name,
                    address: _AddressPrimaryEmployer,
                    metadata: _metaPrimaryEmployer
                }
            );
        }


        //If no accoutns found..add one by default.
        if (primaryemployers.length == 0) {
            primaryemployers.push(this.GiveANewPrimaryEmployer());

        }

        return primaryemployers;
    }
    GiveANewPrimaryEmployer() {
        let m: PrimaryEmployer = new PrimaryEmployer();
        let _metaPrimaryEmployer: Questionnaire = this.dataService.CreateQuestionnaireObject(this.myaccountdata.QuestionDefinitions, this.Key_MANUALPRIMARYEMPLOYER, []);
        m.metadata = _metaPrimaryEmployer;
        m.position = this.PrimaryEmployer_PositionIdFor_EMPLOYEE;
        return m;
    }

    SetPrimaryPracticeLocationInUIDATA() {
        let thiscomponent = this;
        this.dataService.uidata.PracticeLocation = [];
        let xmlstring = this.myaccountdata.QuestionDefinitions.filter(function (s) { return s.acep_QuestionnaireKey === thiscomponent.Key_PrimaryPracticeLocation })[0].Acep_DefinitionXML;
        let $xml = $($.parseXML(xmlstring));
        $xml.find("field").each(function (index, elem) {
            // $(elem).attr('name')
            // $(elem).attr('value')
            thiscomponent.dataService.uidata.PracticeLocation.push({ label: $(elem).attr('name'), value: $(elem).attr('value') })

        });
    }

    SetEmploymentStatusInUIDATA() {
        let thiscomponent = this;
        this.dataService.uidata.EmploymentStatus = [];
        let xmlstring = this.myaccountdata.QuestionDefinitions.filter(function (s) { return s.acep_QuestionnaireKey === thiscomponent.Key_EmploymentStatus })[0].Acep_DefinitionXML;
        let $xml = $($.parseXML(xmlstring));
        $xml.find("field").each(function (index, elem) {
            // $(elem).attr('name')
            // $(elem).attr('value')
            thiscomponent.dataService.uidata.EmploymentStatus.push({ label: $(elem).attr('name'), value: $(elem).attr('value') })

        });
    }


    //type: Education/Career
    ExtractHtmlForManualPrograms(type: string) {
        let htmlManual = '';

        let html = '';
        if (type == 'Education') {
            let manualPrograms_MedicalSchool = this.myaccountdata.education.medicalschools.filter(function (s) { return s.address.address2 != '' });
            let manualPrograms_Internship = this.myaccountdata.education.internships.filter(function (s) { return s.address.address2 != '' });
            let manualPrograms_Residency = this.myaccountdata.education.residencies.filter(function (s) { return s.address.address2 != '' });
            let manualPrograms_Fellowship = this.myaccountdata.education.fellowships.filter(function (s) { return s.address.address2 != '' });

            //if(manualPrograms_MedicalSchool.length + manualPrograms_Internship.length + manualPrograms_Residency.length + manualPrograms_Fellowship.length == 0) return html;

            html += this.GetHtmlForAllProgramsInAType(manualPrograms_MedicalSchool, "MEDICAL SCHOOL");
            html += this.GetHtmlForAllProgramsInAType(manualPrograms_Internship, "INTERNSHIP");
            html += this.GetHtmlForAllProgramsInAType(manualPrograms_Residency, "RESIDENCY");
            html += this.GetHtmlForAllProgramsInAType(manualPrograms_Fellowship, "FELLOWSHIP");

        }
        
        else {
            //Career
            let manualPrograms_PrimaryEmployer = this.myaccountdata.career.employers.filter(function (s) { return s.address.address2 != '' });
            html += this.GetHtmlForAllProgramsInAType(manualPrograms_PrimaryEmployer, "PRIMARY EMPLOYER");
        }

        if (html != '') {
            htmlManual += `<h3>A request to add a new institution has been submitted through the ${this.globalDataOpsService.ORG} Dashboard.</h3><br/>`;
            htmlManual += "<b>Please find below the details of the request:</b><br />";
            htmlManual += "<table>";
            htmlManual += `<tr><td>ACEP ID:</td><td>${this.ssosvc.acepid}</td><tr>`
            htmlManual += `<tr><td>Member Name:</td><td>${this.myaccountdata.primaryContact.personalinfo.firstname} ${this.myaccountdata.primaryContact.personalinfo.lastname}</td><tr>`;
            htmlManual += html;
            htmlManual += "</table>";
            htmlManual = btoa(htmlManual);
        }

        return htmlManual;
    }

    private GetHtmlForAllProgramsInAType(manualPrograms: any, type: string): string {
        let html = '';
        if (manualPrograms.length > 0) {
            html += `<tr><td colspan='2'><h4>${type}</h4></td><tr>`
            for (let m of manualPrograms) {
                html += this.FormatEmailContentForManualProgram(m, m.address);
            }
        }
        return html;

    }



    private FormatEmailContentForManualProgram(program: any, address: any) {
        let html = '<hr/>';
        html += `<tr><td>Name:</td><td>${program.name}</td><tr>`
        html += `<tr><td>Address Line 1:</td><td>${address.address2}</td><tr>`
        html += `<tr><td>Address Line 2:</td><td>${address.address3}</td><tr>`
        html += `<tr><td>City:</td><td>${address.city}</td><tr>`
        html += `<tr><td>State/Province:</td><td>${address.state}</td><tr>`
        html += `<tr><td>Country:</td><td>${address.country}</td><tr>`
        html += `<tr><td>Postal Code:</td><td>${address.zip}</td><tr>`
        return html;

    }

   


}